import React, { useState, useContext, useEffect } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import { CiEdit } from 'react-icons/ci';
import { DataContext } from '../context/DataProvider';
import { BiSolidEditAlt } from 'react-icons/bi';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { RiShieldKeyholeLine } from 'react-icons/ri';
import { FaRegWindowClose } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { BiMessageSquareAdd } from 'react-icons/bi';
import SearchableDropDownPermissionList from '../SearchableDropDown/SearchableDropDownPermissionList';

const RolePermissionList = () => {
  const { name, id, description } = useParams();
  const [searchParams, setsearchParams] = useSearchParams();
  const page: any = searchParams.get('page');
  let rowNumber = page ? (page - 1) * 30 : 0;
  const [openNew, setOpenNew] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [IdDelete, setIdDelete] = useState(0);
  const [savePage, setSavePage] = useState(1);
  const [permissionRoleList, setPermissionRoleList] = useState([]);
  const [permissionID, setPermissionID] = useState(0);

  const [permissionRoleCount, setPermissionRoleCount] = useState(0);
  const RolePermissionTitle = 'لیست مجوز های نقش' + ' ' + description;
  const { tokenLogin,CookieToken, loading, setLoading, isTokenExpired,NewfetchRefreshToken,permissionId,setPermissionId }: any =
    useContext(DataContext);
  console.log(permissionRoleList);
  const onChangePage = (data: any) => {
    setsearchParams({ page: data.selected + 1 });
    setSavePage(data.selected + 1);
  };
  const GetPermissionList = () => {
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/api/RolePermission/GetRolePermissionList`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/RolePermission/GetRolePermissionList`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        filters: {
          pageNumber: page === null ? 1 : page,
          pageSize: 30,
          isSortAscending: true,
          sortField: '',
          search: '',
        },
        roleId: id,
        claimType: '',
        claimValue: '',
        description: '',
        isActivePermission: true,
        isActiveRolePermission: true,
      }),
    };
    try {
      axios.request(config).then((res) => {
        const list = res.data;
        console.log(list.data);
        setPermissionRoleList(list.data.items);
        setPermissionRoleCount(list.data.totalItems);
        // setRoleByID(list.data);
        // setPermissionRoleModal(true)
      });
    } catch (error) {}
  };
  const DeletePermissionOfRole = () => {
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/api/RolePermission/RemovePermissionFromRole`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/RolePermission/RemovePermissionFromRole`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        roleId: id,
        permissionId: IdDelete,
      }),
    };
    try {
      if (isTokenExpired(CookieToken.accessToken)) {
        NewfetchRefreshToken()
      } else {
        axios.request(config).then((res) => {
          const list = res.data;
          console.log(list.data);

          alert(`${list.data.message}`);
          GetPermissionList();
        });
      }
    } catch (error) {}
  };
  const ChangeRolePermissionStatus = (ID: number, Active: string) => {
    const isActivePermission = Active === 'true' ? true : false;
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/api/RolePermission/ChangeRolePermissionStatus`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/RolePermission/ChangeRolePermissionStatus`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        permissionId: ID,
        roleId: id,
        roleName: name,
        isActive: isActivePermission,
      }),
    };
    if (isTokenExpired(CookieToken.accessToken)) {
      NewfetchRefreshToken()
    } else {
      try {
        axios.request(config).then((res) => {
          const list = res.data;
          console.log(list.data);
          alert(`${list.data.message}`);
          GetPermissionList();
        });
      } catch (error) {
        console.log('ErrorChangeRolePermissionStatus', error);
      }
    }
  };
  const AddPermissionToRole = () => {
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/api/RolePermission/AddPermissionToRole`,
      // url: `${process.env.REACT_APP_BASE_URL_LAW_MINER_PLUS}/v1/RolePermission/AddPermissionToRole`,
      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        roleId: id,
        permissionId: permissionId,
      }),
    };
    if (isTokenExpired(CookieToken.accessToken)) {
      NewfetchRefreshToken()
    } else {
      try {
        axios.request(config).then((res) => {
          const list = res.data;
          console.log(list.data);
          alert(`${list.data.message}`);
          setOpenNew(false)
          GetPermissionList();
        });
      } catch (error) {
        console.log('ErrorAddPermissionToRole', error);
      }
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    GetPermissionList();
  }, [page]);
  return (
    <>
      <Breadcrumb pageName={`${RolePermissionTitle}`} />

      <div className="w-full font-IranSans  max-w-full p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className=" flex w-full items-center grid grid-cols-1 gap-3">
          {!openNew && (
            <div className="w-full rtl">
              <button
                className=" md:mt-0 mt-3 "
                onClick={() => setOpenNew(!openNew)}
              >
                <span className="box font-IranSans text-[16px]">
                  افزودن مجوز جدید{' '}
                </span>
              </button>
            </div>
          )}
          {openNew && (
            <div className="w-full  rtl mb-4 mt-3 flex items-center font-IranSans">
              {/* <select onClick={(e)=>setPermissionID(Number(e.target.value))} className="border w-[35%] p-1 rounded-md ml-4">


              </select> */}
{/* <div className='w-full rtl'> */}
  <SearchableDropDownPermissionList/>
{/* </div> */}
              <button
                onClick={AddPermissionToRole}
                className="w-24 p-2 mr-3 border hover:border-[#65B741] hover:bg-white hover:text-[#65B741] font-IranSans rounded-full flex items-center justify-center text-[14px]  text-white bg-[#65B741] font-bold"
              >
                ثبت مجوز
              </button>
            </div>
          )}
        </div>

        <div className="w-full">
          <table className="overflow-auto w-full">
            <thead>
              <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                <th className="w-5 border-b p-3 text-[14px] text-center">
                  ردیف
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  نام مجوز
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  توضیحات
                </th>

                <th className="w-10 border-b p-3 text-[14px] text-center">
                  وضعیت مجوز
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  وضعیت مجوز در نقش
                </th>

                <th className="w-10 border-b p-3 text-[14px] text-center">
                  حذف
                </th>
              </tr>
            </thead>
            <tbody>
              {permissionRoleList.map((item) => {
                return (
                  <>
                    <tr className="cursor-pointer w-full">
                      <td className="w-5 border-b p-3 text-[14px] text-center">
                        {(rowNumber = rowNumber + 1)}
                      </td>
                      <td className="w-10 border-b p-3 text-[14px]   text-center">
                        {item.claimValue}
                      </td>
                      <td className=" w-10 border-b p-3 text-[14px]   text-center">
                        {item.description}
                      </td>{' '}
                      <td className="w-10 border-b p-3 text-[14px] text-center">
                        {item.isActivePermission ? (
                          <span className="w-full flex items-center justify-center">
                            فعال
                          </span>
                        ) : (
                          <span className="w-full flex items-center justify-center">
                            غیر فعال
                          </span>
                        )}
                      </td>
                      <td className="w-10 border-b p-3 text-[14px] text-center">
                        <select
                          onChange={(e) =>
                            ChangeRolePermissionStatus(
                              item.permissionId,
                              e.target.value,
                            )
                          }
                        >
                          {item.isActiveRolePermission ? (
                            <option
                              value="true"
                              selected
                              className="w-full flex items-center justify-center"
                            >
                              فعال
                            </option>
                          ) : (
                            <option
                              value="true"
                              className="w-full flex items-center justify-center"
                            >
                              فعال
                            </option>
                          )}
                          {!item.isActiveRolePermission ? (
                            <option
                              value="false"
                              selected
                              className="w-full flex items-center justify-center"
                            >
                              غیر فعال
                            </option>
                          ) : (
                            <option
                              value="false"
                              className="w-full flex items-center justify-center"
                            >
                              غیر فعال
                            </option>
                          )}
                        </select>
                      </td>
                      <td className="w-10 border-b p-3 text-[14px] text-center">
                        <span className="w-full flex items-center justify-center">
                          <button
                            className="bin-button"
                            onClick={() => {
                              setOpenDelete(true);
                              setIdDelete(item.permissionId);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 39 7"
                              className="bin-top"
                            >
                              <line
                                stroke-width="4"
                                stroke="white"
                                y2="5"
                                x2="39"
                                y1="5"
                              ></line>
                              <line
                                stroke-width="3"
                                stroke="white"
                                y2="1.5"
                                x2="26.0357"
                                y1="1.5"
                                x1="12"
                              ></line>
                            </svg>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 33 39"
                              className="bin-bottom"
                            >
                              <mask fill="white" id="path-1-inside-1_8_19">
                                <path d="M0 0H33V35C33 37.2091 31.2091 39 29 39H4C1.79086 39 0 37.2091 0 35V0Z"></path>
                              </mask>
                              <path
                                mask="url(#path-1-inside-1_8_19)"
                                fill="white"
                                d="M0 0H33H0ZM37 35C37 39.4183 33.4183 43 29 43H4C-0.418278 43 -4 39.4183 -4 35H4H29H37ZM4 43C-0.418278 43 -4 39.4183 -4 35V0H4V35V43ZM37 0V35C37 39.4183 33.4183 43 29 43V35V0H37Z"
                              ></path>
                              <path
                                stroke-width="4"
                                stroke="white"
                                d="M12 6L12 29"
                              ></path>
                              <path
                                stroke-width="4"
                                stroke="white"
                                d="M21 6V29"
                              ></path>
                            </svg>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 89 80"
                              className="garbage"
                            >
                              <path
                                fill="white"
                                d="M20.5 10.5L37.5 15.5L42.5 11.5L51.5 12.5L68.75 0L72 11.5L79.5 12.5H88.5L87 22L68.75 31.5L75.5066 25L86 26L87 35.5L77.5 48L70.5 49.5L80 50L77.5 71.5L63.5 58.5L53.5 68.5L65.5 70.5L45.5 73L35.5 79.5L28 67L16 63L12 51.5L0 48L16 25L22.5 17L20.5 10.5Z"
                              ></path>
                            </svg>
                          </button>
                        </span>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
        <ReactPaginate
          breakLabel={<span className="mr-4 sm:mr-0">...</span>}
          nextLabel={
            <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-1">
              <BsChevronLeft />
            </span>
          }
          onPageChange={onChangePage}
          pageRangeDisplayed={5}
          // pageCount={5}
          pageCount={Math.ceil(permissionRoleCount / 30)}
          previousLabel={
            <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
              <BsChevronRight />
            </span>
          }
          // initialPage={savePage - 1}
          containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
          pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
          activeClassName={
            savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
          }
          // current
        />
        {openDelete && (
          <>
            <div className="ModalBackground">
              <div className="Modal-innerDelete">
                <FaRegWindowClose
                  onClick={() => setOpenDelete(false)}
                  className="top-1"
                />
                <p className="w-full mt-3 text-[18px] IranSans text-center">
                  آیا از حذف مجوز برای این نقش مطمئن هستنید ؟
                </p>
                <div className="flex items-center justify-center w-full  mt-2 ">
                  <button
                    className="w-full border-2 m-2 p-2 rounded-xl bg-[#5D9C59] text-white hover:bg-[#9DC08B]"
                    onClick={DeletePermissionOfRole}
                  >
                    بله
                  </button>
                  <button
                    className="w-full border-2 m-2 p-2 rounded-xl bg-[#DF2E38] text-white text-xl hover:bg-[#E7AB9A]"
                    onClick={() => setOpenDelete(false)}
                  >
                    خیر
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default RolePermissionList;
